import {
    bearerToken,
} from './helpers'
import store from "@/store";
import toast from "@/plugins/izitoast";
import {searchEnumById} from '@/helpers/Utils';

const signalR = require('./../../node_modules/@aspnet/signalr/dist/browser/signalr')

export default class SignalRDeviceCommandsWebhook {

    constructor (connection = null) {
        this.baseURL = process.env.VUE_APP_API_SIGNALR_DEVICE_COMMAND_HOST_V2
        this.connection = connection
        this.accessToken = bearerToken
    }

    connect () {
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(this.baseURL, {
                accessTokenFactory: () => {
                    return this.accessToken()
                },
                transport: 1
            })
            .configureLogging(signalR.LogLevel.Information)
            .build()

        this.connection.connection.onclose((error) => {
            console.info('Disconnected', error)
        })

        return this
    }

    async startListen (id) {
        await this.connection.start()

        let hub = this.connection

        if (!hub['connection'].transport.hasOwnProperty('webSocket')) {
            toast.error('Failed SignalR connection')
            return this
        }

        this.connection = hub

        const connectionUrl = new URL(hub['connection'].transport.webSocket.url)
        const connectionId = connectionUrl.searchParams.get('id');

        store.dispatch('signalRDeviceCommand/setSignalRConnectionId', connectionId)

        return this;
    }

    disconnect () {
        this.connection.stop()

        return this
    }

    sendTrackCommand (id) {
        this.connection.send('trackCommand', id)
    }

    handleDeviceCommandStateChanged () {
        this.connection.on('DeviceCommandStateChanged', (message) => {
            const { id, eventId, hardwareId, state, type } = message

            const typeName = searchEnumById(store.getters['dictionaryModule/getDeviceCommandTypes'], type)
            const stateName = searchEnumById(store.getters['dictionaryModule/getDeviceCommandStates'], state)
            toast.deviceCommandState(
                `${typeName} for ${hardwareId} has been processed with state of ${stateName}`,
                undefined,
                {
                    eventId,
                    hardwareId,
                    typeName,
                    stateName
                }
            )
        })

        return this
    }

}
